import React from 'react'
const excel =[
  {
  id:1,
  img:`./Assets/icons/service-icon-1.png`,
  heading:`IT Staffing & Recruiting`,
  des:`Techsaga's team of talented recruiters has placed thousands of skilled candidates in the IT market over the years.  talents who are critical for achieving the business goals of our clients.`,
},  {
  id:2,
  img:`./Assets/icons/service-icon-1.png`,
  heading:`IT Staffing & Recruiting`,
  des:`Techsaga's team of talented recruiters has placed thousands of skilled candidates in the IT market over the years.  talents who are critical for achieving the business goals of our clients.`,
}
,  {
  id:3,
  img:`./Assets/icons/service-icon-1.png`,
  heading:`IT Staffing & Recruiting`,
  des:`Techsaga's team of talented recruiters has placed thousands of skilled candidates in the IT market over the years.  talents who are critical for achieving the business goals of our clients.`,
}
,  {
  id:4,
  img:`./Assets/icons/service-icon-1.png`,
  heading:`IT Staffing & Recruiting`,
  des:`Techsaga's team of talented recruiters has placed thousands of skilled candidates in the IT market over the years.  talents who are critical for achieving the business goals of our clients.`,
}
]

export const ExcelPoint = () => {
  return (
    <section className="ExcelPoint p-top p-btm m-btm">
         <div className="container">
                <span className="span-hd">Our Excel Point</span>
                    <h2>How Do We Claim To Excel?</h2>
                     <div className="flex spce-btwn align-center">
                           {
                            excel.map((SerEL)=>
                            {
                              return(
                                <div className="box" key={SerEL.id}>
                                <img src={SerEL.img} alt="service" />  
                                <h3>{SerEL.heading}</h3>
                                <p>{SerEL.des}</p>
                             </div>
                              )
                            }
                            )
                             }
                     </div>
                </div>
    </section>

  )
}
